import { AxiosHttpClientAdapter } from '@/core/services/network/infra/adapters/axios.adapter';
import { getApiBaseUrl } from '@/core/utils/apiUtils';
import { SignzyInterface } from '../../domain/interface/SignzyRepository';


export class signzyAdapter implements SignzyInterface {
    private httpClient = new AxiosHttpClientAdapter({
        baseURL: getApiBaseUrl(),
    });

  async submitConsent(consent: string): Promise<string> {
   const data = await this.httpClient.get<{ redirectUrl: string }>(`/src/v?q=${consent}`);
   return data.redirectUrl;
  }
}